var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"tour_map_step3",attrs:{"id":"import_button","block":"","dark":"","large":"","color":"primaryButton","disabled":!_vm.core.enableIdentify},on:{"click":function($event){_vm.core.import.reset_import_modal();
    _vm.core.import.show_import_modal();}}},[_c('v-icon',[_vm._v("mdi-file-upload-outline")]),_c('span',[_vm._v(_vm._s(_vm.$t("common.import")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }